import { createAction } from '@reduxjs/toolkit';

//////////////////////////////////////////////////////////////////////////////////
export const setEntitlement = createAction('SET_ENTITLEMENT');
/////////
